import { render, staticRenderFns } from "./membersModal.vue?vue&type=template&id=22b1a8bf&scoped=true"
import script from "./membersModal.vue?vue&type=script&lang=js"
export * from "./membersModal.vue?vue&type=script&lang=js"
import style0 from "./membersModal.vue?vue&type=style&index=0&id=22b1a8bf&prod&lang=scss"
import style1 from "./membersModal.vue?vue&type=style&index=1&id=22b1a8bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b1a8bf",
  null
  
)

export default component.exports